export default __webpack_public_path__ + "static/grey-car-8563e38cc94c3e76876043f3a59c46f0.png";